import { render } from "./NavigationTabs.vue?vue&type=template&id=61539fec"
import script from "./NavigationTabs.vue?vue&type=script&lang=js"
export * from "./NavigationTabs.vue?vue&type=script&lang=js"

import "./NavigationTabs.vue?vue&type=style&index=0&id=61539fec&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__